import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { identifyBackofficeUser, isPostHogReady } from '../analytics';
import { useAuth } from '../context/AuthContext';
import { useConsent } from '../contexts/ConsentContext';

/**
 * Ré-identifie l'utilisateur quand PostHog devient prêt (ex. consentement accordé après restauration de session).
 */
const PostHogIdentitySync: React.FC = () => {
  useTranslation('common');
  const { user } = useAuth();
  const { consent } = useConsent();

  useEffect(() => {
    if (consent !== 'granted' || !user?.user_id) return;

    if (isPostHogReady()) {
      identifyBackofficeUser(user);
      return;
    }

    const interval = window.setInterval(() => {
      if (!isPostHogReady()) return;
      identifyBackofficeUser(user);
      window.clearInterval(interval);
    }, 400);

    return () => window.clearInterval(interval);
  }, [consent, user]);

  return null;
};

export default PostHogIdentitySync;
